export function IconReportCircle() {
  return (
    <div
      style={{
        border: "2px solid #d3d3d3",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "30px",
        height: "30px",
        color: "#DA9309",
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      !
    </div>
  );
}
